/**
 * screenCapture.ts
 * スクリーンキャプチャ・X共有関連メソッド
 * App.vue から切り出し
 */

import store from '@/store'
// html2canvas (198KB) は使用時に動的ロード
// import html2canvas from 'html2canvas'

type VM = any

export function openDialog(vm: VM) {
  vm.showXDialog = true
  vm.captureAndPreview()
}
export async function captureAndPreview(vm: VM) {

  store.commit('setLoading2', true)
  store.commit('setLoadingMessage', 'キャプチャ中です。')
  const mapDiv = document.getElementById(vm.mapDivId)
  if (!mapDiv) {
    alert('地図が見つかりません')
    return
  }
  const map01 = vm.$store.state.map01
  const currentZoom = map01.getZoom()
  map01.zoomTo(currentZoom + 0.00000000000000000000000000001)
  map01.once('idle', async () => {
    const html2canvas = (await import('html2canvas')).default
    const canvas = await html2canvas(mapDiv, { useCORS: true })
    vm.imgUrl = canvas.toDataURL('image/png')
    // サーバーへアップロード
    const blob: Blob | null = await new Promise(res => canvas.toBlob(res, 'image/png'))
    if (!blob) return
    const formData = new FormData()
    formData.append('file', blob)
    formData.append('spaUrl', window.location.href)

    const res = await fetch('/oh3/php/x-upload.php', { method: 'POST', body: formData })
    const data = await res.json()
    vm.$store.commit('setUrlForX', data.shareUrl)
    store.commit('setLoading2', false)
  })
}